module.exports = __webpack_public_path__ + "static/avatar.af44ff8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jpg/avatar.jpg
// module id = 197
// module chunks = 114276838955818 198517197184460